import { GOAL_MEASUREMENT_TYPES, GOAL_PROGRESS_OPTIONS_MAP } from 'constants/ProjectConstants';
import { indianFormattedNumber, notNullOrUndefined } from 'constants/helper';

export function getGoalProgressMarks({ isInverse, isPrefix, targetValue, initialValue, unitSymbol }) {
  return [
    {
      value: isInverse ? targetValue : initialValue,
      label: isPrefix ? `${unitSymbol}${indianFormattedNumber(initialValue)}` : `${initialValue}${unitSymbol}`,
    },
    {
      value: isInverse ? initialValue : targetValue,
      label: isPrefix ? `${unitSymbol}${indianFormattedNumber(targetValue)}` : `${targetValue}${unitSymbol}`,
    },
  ];
}

export function getMatchedTypeFromUnit(unit) {
  const matchedType = GOAL_MEASUREMENT_TYPES.filter((type) => type.value === unit);
  return matchedType.length === 1 ? matchedType[0] : { label: '', isPrefix: true };
}

export function getGoalProgress({ round = 2, defaultDisplayValue, startValue = 0, achievedValue, targetValue }) {
  // in case startValue and targetValue is not defined Or are equal 0 progress.
  if (startValue === targetValue) return 0;

  if (notNullOrUndefined(targetValue) && notNullOrUndefined(achievedValue)) {
    const percent = Number(((achievedValue - startValue) / (targetValue - startValue)) * 100).toFixed(round);
    const decimalSplit = percent.split('.');
    if (Number(decimalSplit[1]) === 0) {
      return decimalSplit[0];
    }
    return percent;
  }

  return defaultDisplayValue || 0;
}

export function getColorFromGoalProgressLevel(progressLevel) {
  return GOAL_PROGRESS_OPTIONS_MAP[progressLevel]?.color;
}
